'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEqual } from 'underscore';
import { HORIZONTAL, VERTICAL } from 'DesignData/enums/AxisDirections';
import * as SizeUnits from 'DesignData/enums/SizeUnits';
import { isNullOrUndefined } from 'DesignData/lib/validation';
import UIBox from 'UIComponents/layout/UIBox';
import PaneSize from 'DesignData/models/PaneSize';
export default class Pane extends PureComponent {
  constructor(props) {
    super(props);
    const {
      size,
      defaultSize
    } = this.props;
    let initialSize = null;

    if (!isNullOrUndefined(size)) {
      initialSize = size;
    } else if (!isNullOrUndefined(defaultSize)) {
      initialSize = defaultSize;
    }

    this.state = {
      size: initialSize
    };
  }

  componentDidUpdate(prevProps) {
    const {
      size,
      defaultSize
    } = prevProps;
    const {
      size: nextSize,
      defaultSize: nextDefaultSize
    } = this.props;

    if (size !== nextSize && nextSize) {
      this.setState({
        size: nextSize
      });
    } else if (!isEqual(defaultSize, nextDefaultSize)) {
      this.setState({
        size: nextDefaultSize
      });
    }
  }

  isVertical() {
    return this.props.direction === VERTICAL;
  }

  formatPercentage(percentage) {
    return !isNullOrUndefined(percentage) ? `${percentage}%` : null;
  }

  getValue(valueProp) {
    if (!valueProp) {
      return null;
    }

    const {
      value,
      units
    } = valueProp;
    return units === SizeUnits.PERCENT ? this.formatPercentage(value) : value;
  }

  getSizeProps() {
    const {
      size
    } = this.state;
    const {
      minSize
    } = this.props;
    const dimension = this.isVertical() ? 'width' : 'height';
    const style = {
      [this.isVertical() ? 'minWidth' : 'minHeight']: this.getValue(minSize)
    };

    if (!isNullOrUndefined(size)) {
      return {
        style: Object.assign({}, style, {
          [dimension]: this.getValue(size)
        }),
        grow: size.units === SizeUnits.PERCENT ? 1 : undefined,
        shrink: size.units === SizeUnits.PIXELS ? 0 : undefined
      };
      /* eslint-enable no-undefined */
    }

    return {
      style,
      grow: 1
    };
  }

  render() {
    const {
      children,
      className,
      direction,
      forceChildRerender,
      hidden,
      scrollable
    } = this.props;
    const paneClasses = classNames('resizable-pane', className, hidden && 'display-none', direction === HORIZONTAL && 'is--horizontal', direction === VERTICAL && 'is--vertical', scrollable && 'is--scrollable');
    const child = forceChildRerender ? /*#__PURE__*/cloneElement(children, {
      paneProps: this.props
    }) : children;
    return /*#__PURE__*/_jsx(UIBox, Object.assign({}, this.getSizeProps(), {
      className: paneClasses,
      children: child
    }));
  }

}
Pane.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  defaultSize: PropTypes.instanceOf(PaneSize),
  direction: PropTypes.oneOf([HORIZONTAL, VERTICAL]),
  forceChildRerender: PropTypes.bool,
  hidden: PropTypes.bool,
  minSize: PropTypes.instanceOf(PaneSize),
  paneId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resizeDisabled: PropTypes.bool,
  scrollable: PropTypes.bool,
  size: PropTypes.instanceOf(PaneSize),
  unitsOnResize: PropTypes.oneOf(Object.values(SizeUnits || {}))
};
Pane.defaultProps = {
  className: '',
  forceChildRerender: false,
  resizeDisabled: false,
  scrollable: true,
  unitsOnResize: SizeUnits.PERCENT
};